import { Component } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { Card, Select, MenuItem } from "@mui/material"
import { colorWithOpacity } from "helpers/colors"
import Row from "./row"
import "./styles.scss"

export default class SmartTradePanel extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })),
    setGroup: PropTypes.func.isRequired,
    selectedGroup: PropTypes.string.isRequired,
    groups: PropTypes.array.isRequired,
    color: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  onChange = event => {
    const { setGroup } = this.props
    setGroup(event.target.value)
  }

  openPositionProfile = (item) => {
    const { dispatch } = this.props
    if (!item.action) { return null }
    return () => {
      dispatch(item.action)
    }
  }

  render() {
    const { items, groups, selectedGroup, color } = this.props
    const style = color ? { backgroundColor: colorWithOpacity(color, 0.1) } : null
    return <div className="group-panel">
      <Card square>
        <div className="top-panel-row">
          <Select
            variant="standard"
            className="group-select-input"
            value={selectedGroup}
            onChange={this.onChange}
          >
            {map(groups, ({ label, value, id }) =>
              <MenuItem key={id} value={value}>{label}</MenuItem>,
            )}
          </Select>
        </div>
        <div className="panel-wrapper" style={style}>
          {map(items, (item, index) => {
            const { label, value, chartWidth, raw } = item
            return (<div key={index} className="panel-row">
              <Row color={color} value={value} label={label} chartWidth={chartWidth} raw={raw} openPositionProfile={this.openPositionProfile(item)} />
            </div>)
          })}
        </div>
      </Card>
    </div>
  }
}
